module.exports = __webpack_public_path__ + "img/money-block.fabcb8a0.svg";